import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import axios from "axios";

const {REACT_APP_BASE_URL} = process.env;

axios.defaults.baseURL = REACT_APP_BASE_URL;
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem("jwtToken");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
